import { Agent } from "../types/Agent";
import { AgentCard } from "./AgentCard";
import React from "react";

export function AgentList({ agents }: { agents: Agent[] }) {
  return (
    <ul
      role="list"
      className="grid grid-cols-1 gap-x-6 gap-y-5 lg:grid-cols-1 xl:gap-x-8 p-3 sm:p-6"
    >
      {agents.map((agent) => (
        <AgentCard key={agent.id} agent={agent} />
      ))}
    </ul>
  );
}
